/**
 * GTM - Google Tag Manager Module
 *
 * Filename: fxxl_gtm.ts
 *
 * @category  Fahrradxxl
 * @author    Janik Kemnade <j.kemnade@fahrrad-xxl.de>
 * @copyright 2026 Fahrrad-xxl.de
 */



/* 📜 INFORMATION
 * --------------------------------------------------------------------------------------------------------------------
 * Handler für alles GTM.
 *
 * FxxlGTM:
 *
 *
 * FxxlGTMView:
 *
 *
 * FxxlGTMEvent:
 *
 *
 */



/* 📑 TODO
 * --------------------------------------------------------------------------------------------------------------------
 * -
 */






/* 📦️ IMPORTS & EXPORTS
 * ----------------------------------------------------------------------------------------------------------------- */
// Imports
import FxxlCore  from '@fxxl/core';
import FxxlError from '@fxxl/error';

// Exports
export {
    EVENT as GTM_EVENT,
    IGTMDataLayerEntry,
    IGTMDataLayerProductData,
    IGTMAdditionalData,
    FxxlGTM,
    FxxlGTMView,
    FxxlGTMEvent,
}






/* 📑 ENUMS & TYPES & CONSTANTS
 * ----------------------------------------------------------------------------------------------------------------- */
// Error Messages
enum ERROR_MESSAGE {
    INSTANCE_EXISTS     = 'Error: Fxxl GTM: Instance already exists',
    PARAMETER_WRONG     = 'Error: Fxxl GTM: Wrong Parameter',
    EVENT_NOT_EXISTING  = 'Error: Fxxl GTM: Event does not exist',
    DL_PUSH_INVALID     = 'Error: Fxxl GTM: DataLayer push invalid',
}

// HTML Classes
enum HTMLCLASS {}

// Selectors
const SELECTOR = {};

// Event Names
enum EVENT {

    /* 🏷️ All Pages
     * ----------------------------------------------------------------------------------------- */
    // EEC - Funnel
    EEC_PRODUCT_VIEW       = 'EECproductView',
    EEC_PRODUCT_IMPRESSION = 'EECproductImpression',
    EEC_PRODUCT_CLICK      = 'EECproductClick',
    EEC_ADD_TO_CART        = 'EECaddToCart',
    EEC_REMOVE_FROM_CART   = 'EECremoveFromCart',
    EEC_CHECKOUT           = 'EECcheckOut',
    EEC_CHECKOUT2To4       = 'EECcheckOut2To4',
    EEC_ORDER_SUBMITTED    = 'EECorderSubmitted',

    // Customer Data
    CUSTOMER_DATA_INIT = 'customerData',
    CUSTOMER_DATA_BRANCH_FILTER_DATA_UPDATE = 'customerData_branch_data--update',

    // Newsletter Popup
    NEWSLETTER_POPUP_SHOW   = 'fxxl_newsletter_popup--show',
    NEWSLETTER_POPUP_HIDE   = 'fxxl_newsletter_popup--hide',
    NEWSLETTER_POPUP_SUBMIT = 'fxxl_newsletter_popup--submit',

    // PayPal Button
    PAYPAL_BUTTON_EXPRESS_CLICK  = 'fxxl_paypal_button_express--click',
    PAYPAL_BUTTON_PAYLATER_CLICK = 'fxxl_paypal_button_paylater--click',

    // PayPal Wdiget - Pay Later
    PAYPAL_WIDGET_PAYLATER_SHOW = 'fxxl_paypal_widget_paylater--show',
    PAYPAL_WIDGET_PAYLATER_HIDE = 'fxxl_paypal_widget_paylater--hide',


    /* 🏷️ Artikel Detail
     * ----------------------------------------------------------------------------------------- */



    /* 🏷️ Checkout
     * ----------------------------------------------------------------------------------------- */
    // Checkout 4
    CHECKOUT4_PAYMENT_METHOD_CHANGE = 'fxxl_checkout4payment_method--change',
    CHECKOUT4_LEASING_POPUP_OPEN    = 'fxxl_checkout4_leasingautomation_popup_message--open',

}

// Data Key Names
enum DATA_KEY {

    /* 🏷️ All Pages
     * ----------------------------------------------------------------------------------------- */
    CUSTOMER                 = 'customer',
    NEWSLETTER_POPUP         = 'dataNewsletterPopup',


    /* 🏷️ Artikel Detail
     * ----------------------------------------------------------------------------------------- */
    PAYPAL_WIDGET_PAYLATER   = 'dataPayPalWidgetPaylater',


    /* 🏷️ Checkout
     * ----------------------------------------------------------------------------------------- */
    CHECKOUT4_PAYMENT_METHOD = 'dataPaymentMethod',
    CHECKOUT4_LEASING_POPUP  = 'dataLeasingPopup',
}

// Action Field List Names
// INFO: Comming soon
// enum ACTION_FIELD_LIST {
//     EEC_ADD_TO_CART_LINEXO = 'add_to_cart_linexo',
// }

// FxxlGTMView - View Handler
enum GTM_VIEW_HANDLER {
    STARTSEITE = 'initHandlerStartseite',
    CHECKOUT4  = 'initHandlerWarenkorbCheckout4',
}

// TEMPLATE: EEC Data
// INFO: Comming soon
// const TEMPLATE_PRODUCT_DATA: IGTMDataLayerProductData = {
//     id:                         '',
//     product_id:                 '',
//     variant:                    '',
//     name:                       '',
//     price:                      0,
//     org_price:                  0,
//     priceBrutto:                0,
//     delivery_cost:              0,
//     quantity:                   1,
//     size:                       '',
//     category:                   '',
//     productCategorieHierarchy:  '',
//     productgroup:               '',
//     brand:                      '',
//     breadcrumb:                 '',
//     color:                      '',
// }

// TEMPLATE: EEC Data
// INFO: Comming soon
// const TEMPLATE_EEC_DATA = {
//     addToCart: (listName: string, products: IGTMDataLayerProductData): any => {
//         return {
//             ecommerce: {
//                 add: {
//                     actionField: { list: listName },
//                     products: [ products ]
//                 }
//             }
//         }
//     }
// }






/* 💾 INTERFACES
 * ----------------------------------------------------------------------------------------------------------------- */
interface IGTMDataLayerEntry {
    event?: EVENT;
    data?:  object;
}

interface IGTMDataLayerProductData {
    // DEFAULT: Dataset
    id:                         string;
    product_id:                 string;
    variant:                    string;
    name:                       string;
    price:                      number;
    org_price:                  number;
    priceBrutto:                number;
    delivery_cost:              number;
    quantity:                   number;
    size:                       string;
    category:                   string;
    productCategorieHierarchy:  string;
    productgroup:               string;
    brand:                      string;
    breadcrumb:                 string;
    color:                      string;

    // EXTRA: Linexo)
    // INFO: Comming soon
    // devicetype?:                string;
    // producttype?:               string;
    // productcode?:               string;
    // risktypes?:                 string[];
    // paymentinterval?:           number;
    // selectText?:                string;
    // warenkorbText?:             string;
}

interface IGTMAdditionalData {
    linexo: Record<string, IGTMDataLayerProductData>;
}






/* ✒️ CLASS: FxxlGTM
 * --------------------------------------------------------------------------------------------------------------------
 * Holds helper and functionality for pushing data structured to the DataLayer
 * - FxxlGTMView: Initiates per page handling
 * - FxxlGTMEvent Provides functionality for specific DataLayer pushes
 */
class FxxlGTM {

    /* 🏷️ VARS
     * ----------------------------------------------------------------------------------------- */
    // DataLayer & Data Holder for later usage
    public static DATALAYER: any[]                    = FxxlCore.windowVariable('dataLayer')       || [];
    public static ADDITIONAL_DATA: IGTMAdditionalData = FxxlCore.windowVariable('additional_data') || {};




    /* 🐙 STATIC Helper -> Push ( Event, Data )
     * ----------------------------------------------------------------------------------------- */
    // MAIN
    private static push(entry: IGTMDataLayerEntry): void {
        const { event = '', data = {} } = entry;
        const hasEvent:     boolean = typeof event === 'string' && event !== '';
        const hasData:      boolean = data && Object.keys(data).length > 0;
        const isValidEvent: boolean = hasEvent && Object.values(EVENT).includes(event as EVENT);

        // Only Event
        if (hasEvent && !hasData) {
            FxxlGTM.DATALAYER.push({ event });
            return;
        }

        // Only Data
        if (!hasEvent && hasData) {
            FxxlGTM.DATALAYER.push(data);
            return;
        }

        // Event & Data
        if (isValidEvent && hasData) {
            FxxlGTM.DATALAYER.push({ event, ...data });
            return;
        }

        new FxxlError(ERROR_MESSAGE.DL_PUSH_INVALID);
    }

    // HELPER Functions for push
    public static pushEvent(event: EVENT):                   void { FxxlGTM.push({ event });       }
    public static pushData(data: object):                    void { FxxlGTM.push({ data });        }
    public static pushEventData(event: EVENT, data: object): void { FxxlGTM.push({ event, data }); }
    public static pushNamedEventData(event: EVENT, name: DATA_KEY, data: object): void {
        FxxlGTM.push({ event, data: { [name]: data } });
    }

    // PUSH ON VISIBLE
    // // Comming soon
    // Soll dev/customer_fahrradxxl/custom/module/public/fxxl3/assets/js/400_gtm.js -> pushOnVisible ersetzen
    //
    // public static pushOnVisible(event: EVENT, data: object, selector: string): void {
    //     document.addEventListener('scroll', () => {
    //         (document.querySelectorAll(selector) as NodeListOf<HTMLElement>)
    //             .forEach((element: HTMLElement) => {
    //                 if (
    //                     FxxlCore.elementInViewport(element)
    //                     && !element.hasAttribute('datalayer-pushed')
    //                 ) {
    //                     element.setAttribute('datalayer-pushed', '');
    //                     FxxlGTM.push({ event, data });
    //                 }
    //             });
    //     });
    // }

}






/* ✒️ CLASS: FxxlGTMView
 * --------------------------------------------------------------------------------------------------------------------
 * Initiates per Page GTM Event Handling
 * Serves as the main place for every EEC Functionality currently handled here:
 * dev/customer_fahrradxxl/custom/module/public/fxxl3/tagmanager/tagmanager.tpl:174
 * And serves as the main place for DataLayer Push Calls that need to be injected parallel to normal js events
 *
 * Initialization point is: dev/customer_fahrradxxl/custom/module/public/fxxl3/tagmanager/tagmanager.tpl:154
 */
class FxxlGTMView {

    /* 🏷️ VARS
     * ----------------------------------------------------------------------------------------- */
    // Instance Vars
    public static _instance: FxxlGTMView;

    // HTML View Vars
    private get VIEW_TYPE_NAME(): string { return FxxlCore.windowVariable('_vwTypeName') || ''; };
    private get VIEW_NAME():      string { return FxxlCore.windowVariable('_vwName')     || ''; };

    // GTM View Vars
    private viewTypeName!:     string;
    private viewName!:         string;

    private readonly VIEW_HANDLER_BASE_NAME: string = 'initHandler';
    private viewHandlerName!:  string;
    private viewHandler:       ((this: FxxlGTMView) => void) | null = null;




    /* 🐉 CONSTRUCTOR - HELPER
     * ----------------------------------------------------------------------------------------- */
    // EVAL: View Handler
    private evalViewVars(): void {
        // IF: Page is Startseite
        if (document.documentElement.classList.contains('html_startpage')) {
             this.viewHandlerName = GTM_VIEW_HANDLER.STARTSEITE;
             return;
        }

        const viewTypeNameLetterLetter: string = this.VIEW_TYPE_NAME.charAt(0).toUpperCase();
        const viewTypeNameLetterRest:   string = this.VIEW_TYPE_NAME.slice(1);
        const viewNameLetterLetter:     string = this.VIEW_NAME.charAt(0).toUpperCase();
        const viewNameLetterRest:       string = this.VIEW_NAME.slice(1);
        this.viewTypeName                      = `${viewTypeNameLetterLetter}${viewTypeNameLetterRest}`;                // z.B. Artikel
        this.viewName                          = `${viewNameLetterLetter}${viewNameLetterRest}`;                        // z.B. Detail
        this.viewHandlerName                   = `${this.VIEW_HANDLER_BASE_NAME}${this.viewTypeName}${this.viewName}`; // z.B. initHandlerArtikelDetail
    }

    // CHECK: Valid Handler Function
    private isValidViewHandler(): boolean {
        return Object.values(GTM_VIEW_HANDLER).includes(this.viewHandlerName as GTM_VIEW_HANDLER);
    }

    // SET: View Handler Function
    private setViewHandlerFunction(): void {
        this.viewHandler = FxxlGTMView.prototype[this.viewHandlerName as keyof FxxlGTMView] as (this: FxxlGTMView) => void;
    }




    /* 🐉 CONSTRUCTOR
     * ----------------------------------------------------------------------------------------- */
    constructor() {
        // EXIT: Only one Instance acceptable
        if (FxxlGTMView._instance) {
            new FxxlError(ERROR_MESSAGE.INSTANCE_EXISTS);
            return;
        }

        FxxlGTMView._instance = this;

        // INIT: View Handling
        if (!this.VIEW_TYPE_NAME || !this.VIEW_NAME) {
            return;
        }

        // EVAL & CHECK: Valid Handler Function
        this.evalViewVars();
        if (!this.isValidViewHandler()) {
            return;
        }

        // SET & CHECK: View Handler Function
        this.setViewHandlerFunction();
        if (!this.viewHandler) {
            return;
        }

        // EXEC: View Handler
        this.viewHandler.call(this);
    }



    /* 🧙 VIEW HANDLER - Startseite
     * ----------------------------------------------------------------------------------------- */
    // HANDLER
    // private initHandlerStartseite(): void {}




    /* 🧙 VIEW HANDLER - Checkout 4
     * ----------------------------------------------------------------------------------------- */
    // HANDLER
    private initHandlerWarenkorbCheckout4(): void {
        this.initCheckout4ChangePaymentMethod();
    }

    // INIT: Payment Method Change
    private initCheckout4ChangePaymentMethod(): void {
        const checkout4: HTMLElement | null = document.querySelector('.fxxl-warenkorb-checkout4');
        if (!checkout4) {
            return;
        }

        const collapsibleHeader: NodeListOf<HTMLElement> = checkout4?.querySelectorAll('.collapsible-header');
        const selectLeasinganbieter: HTMLSelectElement | null = checkout4?.querySelector('#leasinganbieter');

        // HANDLE: Basic Payment Method Selecting
        collapsibleHeader.forEach((header: HTMLElement): void => {
            const headerInput: HTMLElement | null = header?.querySelector('input[name="b_zahlungsweise_id"]');
            let paymentName:               string = headerInput?.dataset?.name || '';
            let paymentIdentifier:         string = headerInput?.dataset?.zw   || '';

            header.addEventListener('click', (): void => {
                // Check if Leasing Partner Input was selected
                if (headerInput?.classList.contains('radio-leasinganbieter')) {
                    paymentName =
                        selectLeasinganbieter?.options?.[selectLeasinganbieter.selectedIndex]?.textContent?.trim()
                        || '';
                    paymentIdentifier = 'leasinganbieter';
                }

                // SEND: Data
                FxxlGTMEvent.pushCheckout4PaymentMethodChange(paymentName, paymentIdentifier);
            });
        });

        // HANDLE: Leasing Partner Selecting
        if (selectLeasinganbieter) {
            let selectedLeasinganbieter: string | null = null;

            selectLeasinganbieter.addEventListener( 'change', function(): void {
                // SEND && Remove the possibility for double Event pushs
                if (this.value && this.value !== selectedLeasinganbieter) {
                    const paymentIdentifier: string = 'leasinganbieter';
                    const paymentName: string = this?.options?.[this.selectedIndex]?.textContent?.trim() || '';
                    FxxlGTMEvent.pushCheckout4PaymentMethodChange(paymentName, paymentIdentifier);
                }

                selectedLeasinganbieter = this.value;
            });
        }
    }

}





/* ✒️ CLASS: FxxlGTMEvent
 * --------------------------------------------------------------------------------------------------------------------
 * Serves as the main place for static DataLayer Push Calls needed by page feature functionality
 */
class FxxlGTMEvent {

    /* 🐙 PUSH: CustomerData Events
     * ----------------------------------------------------------------------------------------- */
    // Branch Filter Data - Update
    public static pushCustomerDataBranchFilterDataUpdate(branchFilterData: object): void {
        FxxlGTM.pushNamedEventData(EVENT.CUSTOMER_DATA_BRANCH_FILTER_DATA_UPDATE, DATA_KEY.CUSTOMER, {
            branchfilterdata: branchFilterData
        });
    }




    /* 🐙 PUSH: Newesletter Popup Events
     * ----------------------------------------------------------------------------------------- */
    // Newsletter Popup - Show
    public static pushNewsletterPopupShow(): void {
        FxxlGTM.pushEvent(EVENT.NEWSLETTER_POPUP_SHOW);
    }

    // Newsletter Popup - Hide
    public static pushNewsletterPopupHide(): void {
        FxxlGTM.pushEvent(EVENT.NEWSLETTER_POPUP_HIDE);
    }

    // Newsletter Popup - Hide
    public static pushNewsletterPopupSubmit(email: string, newsletterAgreementText: string): void {
        FxxlGTM.pushNamedEventData(EVENT.NEWSLETTER_POPUP_SUBMIT, DATA_KEY.NEWSLETTER_POPUP, {
            email: email,
            newsletterAgreementText: newsletterAgreementText
        });
    }




    /* 🐙 PUSH: PayPal Events
     * ----------------------------------------------------------------------------------------- */
    // Widget Pay Later - Show
    public static pushPayPalWidgetPayLaterShow(element: HTMLElement): void {
        FxxlGTM.pushNamedEventData(EVENT.PAYPAL_WIDGET_PAYLATER_SHOW, DATA_KEY.PAYPAL_WIDGET_PAYLATER, {
            targetElement: element
        });
    }

    // Widget Pay Later - Hide
    public static pushPayPalWidgetPayLaterHide(element: HTMLElement): void {
        FxxlGTM.pushNamedEventData(EVENT.PAYPAL_WIDGET_PAYLATER_HIDE, DATA_KEY.PAYPAL_WIDGET_PAYLATER, {
            targetElement: element
        });
    }




    /* 🐙 PUSH: Checkout 4 Events
     * ----------------------------------------------------------------------------------------- */
    // Payment Method - Change
    public static pushCheckout4PaymentMethodChange(paymentMethodName: string, paymentMethodIdentifier: string = ''): void {
        FxxlGTM.pushNamedEventData(EVENT.CHECKOUT4_PAYMENT_METHOD_CHANGE, DATA_KEY.CHECKOUT4_PAYMENT_METHOD, {
            name: paymentMethodName,
            identifier: paymentMethodIdentifier
        });
    }


    // Leasing Popup - Show
    public static pushCheckout4LeasingPopupShow(modal: HTMLElement, email: string = ''): void {
        const leasings: HTMLSelectElement | null
            = document.querySelector('select#leasinganbieter');
        const leasingDescription: string | null
            = leasings?.options?.[leasings?.selectedIndex]?.textContent?.trim() || '';
        const message: string
            = modal?.querySelector('.fxxl-leasingautomation-modal-content__text')?.textContent || '';

        FxxlGTM.pushNamedEventData(EVENT.CHECKOUT4_LEASING_POPUP_OPEN, DATA_KEY.CHECKOUT4_LEASING_POPUP, {
            leasingDescription, email, message
        });
    }

}
